/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import type { SVGProps } from 'react';

export const WarningIcon = (props: SVGProps<SVGSVGElement>) => (
  // eslint-disable-next-line react/forbid-elements
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7281 0.6426L25.0657 23.3706C25.2625 23.7642 25.2409 24.2274 25.0105 24.6018C24.7825 24.9714 24.3769 25.1994 23.9401 25.1994H1.26011C0.823308 25.1994 0.417708 24.9714 0.187308 24.5994C-0.0406918 24.2274 -0.0622918 23.7642 0.132108 23.373L11.4721 0.6426C11.8993 -0.2142 13.2985 -0.2142 13.7281 0.6426ZM12.6672 4.16352C12.6396 4.10816 12.5606 4.10816 12.533 4.16352L3.35183 22.5661C3.32695 22.616 3.36322 22.6746 3.41894 22.6746H21.7813C21.837 22.6746 21.8733 22.616 21.8484 22.5661L12.6672 4.16352ZM12.6001 17.8482C13.4689 17.8482 14.1745 18.5562 14.1745 19.425C14.1745 20.2938 13.4689 20.9994 12.6001 20.9994C11.7313 20.9994 11.0257 20.2938 11.0257 19.425C11.0257 18.5562 11.7313 17.8506 12.6001 17.8506V17.8482ZM13.4989 10.1995C13.5818 10.1995 13.6489 10.2666 13.6489 10.3495V16.6494C13.6489 16.7322 13.5818 16.7994 13.4989 16.7994H11.7013C11.6185 16.7994 11.5513 16.7322 11.5513 16.6494V10.3495C11.5513 10.2666 11.6185 10.1995 11.7013 10.1995H13.4989Z"
      fill="currentColor"
    />
  </svg>
);
